import React from 'react';
import { Hidden } from '@material-ui/core';
import { QccoPlanAdoptionWizard } from '../wizards/qcco-plan-adoption-wizard';
import { LayDcPlanAdoptionContentModel } from '../models/plan-adoption-form-models';

interface Props {
    wizard: QccoPlanAdoptionWizard;
    isReadonly?: boolean;
}

export function PlanParticipantRowHeader(props: Props) {

    const { wizard, isReadonly } = props;
    const content: LayDcPlanAdoptionContentModel = wizard?.getFormContentModel();

    return (
        <>
            <Hidden xsDown>
                <div className='plan-adoption-table-row'>
                    <div className='plan-adoption-table-row-cell plan-adoption-table-row-cell-name'>
                        <p className='input-label'>{content?.participantNameLabel}</p>
                    </div>
                    <div className='plan-adoption-table-row-cell'>
                        <p className='input-label'>{content?.contributionTypeLabel}</p>
                    </div>
                    <div className='plan-adoption-table-row-cell'>
                        <p className='input-label'>{content?.contributionAmountLabel}</p>
                    </div>
                    {
                        !isReadonly &&
                        <div className='plan-adoption-table-row-cell'>
                            <p className='input-label'>{content?.contributionEditLabel}</p>
                        </div>
                    }
                </div>
            </Hidden>
        </>);
}

PlanParticipantRowHeader.defaultProps = {
    isReadonly: false,
};